module.exports = __webpack_public_path__ + "assets/img/jcsp.801f1306.png";